import { BackendProvider } from '../adapters/types'

export const isShoonyaBackend = (): boolean =>
    (import.meta.env.VITE_BACKEND_PROVIDER || BackendProvider.TICK2TRADE) === BackendProvider.SHOONYA

export const isAutoLoginEnabled = (): boolean =>
    import.meta.env.VITE_AUTO_LOGIN_ENABLED === 'true'

export const supportsPracticeTrade = (): boolean => !isShoonyaBackend()
